"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
var Merrco_1 = require("../../models/Payments/Merrco");
var generateMerrcoUrl = function (path, apiAuthKey, payload) { return "" + __1.CT_PAYMENTS_URL + path + "?auth-api-key=" + apiAuthKey + "&payload=" + payload; };
exports.MerrcoAPI = {
    merrcoPurchase: function (merrcoRequestEncryptedPayload, apiAuthKey) { return __awaiter(_this, void 0, void 0, function () {
        var merrcoPurchaseUrl, merrcoResponse, responseBody;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    merrcoPurchaseUrl = generateMerrcoUrl('/purchase', apiAuthKey, merrcoRequestEncryptedPayload);
                    return [4 /*yield*/, __1.axios.post(merrcoPurchaseUrl)];
                case 1:
                    merrcoResponse = _a.sent();
                    responseBody = merrcoResponse.data;
                    return [2 /*return*/, responseBody];
            }
        });
    }); },
    merrcoRefund: function (merrcoRequestEncryptedPayload, apiAuthKey) { return __awaiter(_this, void 0, void 0, function () {
        var merrcoRefundUrl, merrcoResponse, responseBody;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    merrcoRefundUrl = generateMerrcoUrl('/refund', apiAuthKey, merrcoRequestEncryptedPayload);
                    return [4 /*yield*/, __1.axios.post(merrcoRefundUrl)];
                case 1:
                    merrcoResponse = _a.sent();
                    responseBody = merrcoResponse.data;
                    return [2 /*return*/, responseBody];
            }
        });
    }); },
    merrcoRecovery: function (merrcoRequestEncryptedPayload, apiAuthKey) { return __awaiter(_this, void 0, void 0, function () {
        var merrcoPurchaseUrl, merrcoResponse, responseBody;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    merrcoPurchaseUrl = generateMerrcoUrl('/recover', apiAuthKey, merrcoRequestEncryptedPayload);
                    return [4 /*yield*/, __1.axios.post(merrcoPurchaseUrl)];
                case 1:
                    merrcoResponse = _a.sent();
                    responseBody = merrcoResponse.data;
                    return [2 /*return*/, responseBody];
            }
        });
    }); },
    merrcoDataCandyActivate: function (merrcoDataCandyRequestEncryptedPayload, apiAuthKey) { return __awaiter(_this, void 0, void 0, function () {
        var merrcoDataCandyPurchaseUrl, merrcoDataCandyResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    merrcoDataCandyPurchaseUrl = generateMerrcoUrl('/datacandy/activate', apiAuthKey, merrcoDataCandyRequestEncryptedPayload);
                    return [4 /*yield*/, __1.axios.post(merrcoDataCandyPurchaseUrl)];
                case 1:
                    merrcoDataCandyResponse = _a.sent();
                    return [2 /*return*/, merrcoDataCandyResponse.data];
            }
        });
    }); },
    merrcoDataCandyIncrement: function (merrcoDataCandyRequestEncryptedPayload, apiAuthKey) { return __awaiter(_this, void 0, void 0, function () {
        var merrcoDataCandyPurchaseUrl, merrcoDataCandyResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    merrcoDataCandyPurchaseUrl = generateMerrcoUrl('/datacandy/increment', apiAuthKey, merrcoDataCandyRequestEncryptedPayload);
                    return [4 /*yield*/, __1.axios.post(merrcoDataCandyPurchaseUrl)];
                case 1:
                    merrcoDataCandyResponse = _a.sent();
                    return [2 /*return*/, merrcoDataCandyResponse.data];
            }
        });
    }); },
    merrcoDataCandyBalance: function (merrcoDataCandyRequestEncryptedPayload, apiAuthKey) { return __awaiter(_this, void 0, void 0, function () {
        var merrcoDataCandyPurchaseUrl, merrcoDataCandyResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    merrcoDataCandyPurchaseUrl = generateMerrcoUrl('/datacandy/balance', apiAuthKey, merrcoDataCandyRequestEncryptedPayload);
                    return [4 /*yield*/, __1.axios.post(merrcoDataCandyPurchaseUrl)];
                case 1:
                    merrcoDataCandyResponse = _a.sent();
                    return [2 /*return*/, merrcoDataCandyResponse.data];
            }
        });
    }); },
    merrcoDataCandyPurchase: function (merrcoDataCandyRequestEncryptedPayload, apiAuthKey) { return __awaiter(_this, void 0, void 0, function () {
        var merrcoDataCandyPurchaseUrl, merrcoDataCandyResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    merrcoDataCandyPurchaseUrl = generateMerrcoUrl('/datacandy/redemption', apiAuthKey, merrcoDataCandyRequestEncryptedPayload);
                    return [4 /*yield*/, __1.axios.post(merrcoDataCandyPurchaseUrl)];
                case 1:
                    merrcoDataCandyResponse = _a.sent();
                    return [2 /*return*/, merrcoDataCandyResponse.data];
            }
        });
    }); },
    merrcoDataCandyCancel: function (merrcoRefundRequestEncryptedPayload, apiAuthKey) { return __awaiter(_this, void 0, void 0, function () {
        var merrcoDataCandyCompleteCancelUrl, merrcoDataCandyResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    merrcoDataCandyCompleteCancelUrl = generateMerrcoUrl('/datacandy/partialCancel', apiAuthKey, merrcoRefundRequestEncryptedPayload);
                    return [4 /*yield*/, __1.axios.post(merrcoDataCandyCompleteCancelUrl)];
                case 1:
                    merrcoDataCandyResponse = _a.sent();
                    return [2 /*return*/, merrcoDataCandyResponse.data];
            }
        });
    }); },
    merrcoTransactionAck: function (merrcoResponse, apiAuthKey) { return __awaiter(_this, void 0, void 0, function () {
        var merrcoAckRequestObject, merrcoAckRequestPayload, merrcoAckEncryptedRequestPayload, merrcoPurchaseUrl, merrcoAckResponse, responseBody;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    merrcoAckRequestObject = {
                        CompanyNumber: merrcoResponse.companyNumber,
                        MerchantNumber: merrcoResponse.merchantNumber,
                        TransactionNumber: merrcoResponse.transactionNumber,
                    };
                    merrcoAckRequestPayload = Merrco_1.jsonToQueryString(merrcoAckRequestObject);
                    merrcoAckEncryptedRequestPayload = Merrco_1.base64Encryption(merrcoAckRequestPayload);
                    merrcoPurchaseUrl = generateMerrcoUrl('/ack', apiAuthKey, merrcoAckEncryptedRequestPayload);
                    return [4 /*yield*/, __1.axios.post(merrcoPurchaseUrl)];
                case 1:
                    merrcoAckResponse = _a.sent();
                    responseBody = merrcoAckResponse.data;
                    return [2 /*return*/, responseBody.returnCode];
            }
        });
    }); },
};
//# sourceMappingURL=MerrcoAPI.js.map